import { Space } from "@/models/space.model";
import { Artwork } from "../../../models/artwork.model";
import { Gallery } from "../../../models/gallery.model";
import User from "../../../models/user.model";

export const GET_USERS = '[ADMIN] Get users';
export const GET_USERS_SUCCESS = '[ADMIN] Get users success';
export const GET_USERS_FAILED = '[ADMIN] Get users failed';

export const GET_SPACES = '[ADMIN] Get spaces';
export const GET_SPACES_SUCCESS = '[ADMIN] Get spaces success';
export const GET_SPACES_FAILED = '[ADMIN] Get spaces failed';

export const ASSIGN_MOOD_TO_USER = '[ADMIN] Assign mood to user';
export const ASSIGN_MOOD_TO_USER_SUCCESS = '[ADMIN] Assign mood to user success';
export const ASSIGN_MOOD_TO_USER_FAILED = '[ADMIN] Assign mood to user failed';

export const UNASSIGN_MOOD_FROM_USER = '[ADMIN] Unassign mood from user';
export const UNASSIGN_MOOD_FROM_USER_SUCCESS = '[ADMIN] Unassign mood from user success';
export const UNASSIGN_MOOD_FROM_USER_FAILED = '[ADMIN] Unassign mood from user failed';

export const GET_DEFAULT_SPACE = '[ADMIN] Get default space';
export const GET_DEFAULT_SPACE_SUCCESS = '[ADMIN] Get default space success';
export const GET_DEFAULT_SPACE_FAILED = '[ADMIN] Get default space failed';

export const GET_GALLERIES = '[ADMIN] Get galleries';
export const GET_GALLERIES_SUCCESS = '[ADMIN] Get galleries success';
export const GET_GALLERIES_FAILED = '[ADMIN] Get galleries failed';

export const UPDATE_GALLERY = '[ADMIN] Update gallery';
export const UPDATE_GALLERY_SUCCESS = '[ADMIN] Update gallery success';
export const UPDATE_GALLERY_FAILED = '[ADMIN] Update gallery failed';

export const CREATE_GALLERY = '[ADMIN] Create gallery';
export const CREATE_GALLERY_SUCCESS = '[ADMIN] Create gallery success';
export const CREATE_GALLERY_FAILED = '[ADMIN] Create gallery failed';

export const GET_ARTWORKS = '[ADMIN] Get Artworks';
export const GET_ARTWORKS_SUCCESS = '[ADMIN] Get Artworks success';
export const GET_ARTWORKS_FAILED = '[ADMIN] Get Artworks failed';

export const UPDATE_ARTWORK = '[ADMIN] Update Artwork';
export const UPDATE_ARTWORK_SUCCESS = '[ADMIN] Update Artwork success';
export const UPDATE_ARTWORK_FAILED = '[ADMIN] Update Artwork failed';

export const CREATE_ARTWORK = '[ADMIN] Create Artwork';
export const CREATE_ARTWORK_SUCCESS = '[ADMIN] Create Artwork success';
export const CREATE_ARTWORK_FAILED = '[ADMIN] Create Artwork failed';

export const DELETE_GALLERY = '[ADMIN] Delete gallery';
export const DELETE_GALLERY_SUCCESS = '[ADMIN] Delete gallery success';
export const DELETE_GALLERY_FAILED = '[ADMIN] Delete gallery failed';

export const DeleteGallery = (payload: string) => {
    return {
        type: DELETE_GALLERY,
        payload
    }
}

export const DeleteGallerySuccess = (payload: string) => {
    return {
        type: DELETE_GALLERY_SUCCESS,
        payload
    }
}

export const DeleteGalleryFailed = (payload: string) => {
    return {
        type: DELETE_GALLERY_FAILED,
        payload
    }
}

export const CreateArtwork = (payload: any) => {
    return {
        type: CREATE_ARTWORK,
        payload
    }
}

export const CreateArtworkSuccess = (payload: Artwork) => {
    return {
        type: CREATE_ARTWORK_SUCCESS,
        payload
    }
}

export const CreateArtworkFailed = (payload: string) => {
    return {
        type: CREATE_ARTWORK_FAILED,
        payload
    }
}

export const UpdateArtwork = (payload: any) => {
    return {
        type: UPDATE_ARTWORK,
        payload
    }
}

export const UpdateArtworkSuccess = (payload: Artwork) => {
    return {
        type: UPDATE_ARTWORK_SUCCESS,
        payload
    }
}

export const UpdateArtworkFailed = (payload: string) => {
    return {
        type: UPDATE_ARTWORK_FAILED,
        payload
    }
}

export const GetArtworks = () => {
    return {
        type: GET_ARTWORKS
    }
}

export const GetArtworksSuccess = (payload: Artwork[]) => {
    return {
        type: GET_ARTWORKS_SUCCESS,
        payload
    }
}

export const GetArtworksFailed = (payload: string) => {
    return {
        type: GET_ARTWORKS_FAILED,
        payload
    }
}

export const CreateGallery = (payload: any) => {
    return {
        type: CREATE_GALLERY,
        payload
    }
}

export const CreateGallerySuccess = (payload: Gallery) => {
    return {
        type: CREATE_GALLERY_SUCCESS,
        payload
    }
}

export const CreateGalleryFailed = (payload: string) => {
    return {
        type: CREATE_GALLERY_FAILED,
        payload
    }
}

export const UpdateGallery = (payload: any) => {
    return {
        type: UPDATE_GALLERY,
        payload
    }
}

export const UpdateGallerySuccess = (payload: Gallery) => {
    return {
        type: UPDATE_GALLERY_SUCCESS,
        payload
    }
}

export const UpdateGalleryFailed = (payload: string) => {
    return {
        type: UPDATE_GALLERY_FAILED,
        payload
    }
}

export const GetGalleries = () => {
    return {
        type: GET_GALLERIES
    }
}

export const GetGalleriesSuccess = (payload: {
    galleries: Gallery[], 
    spaces: Space[],
    artworks: Artwork[],
}) => {
    return {
        type: GET_GALLERIES_SUCCESS,
        payload
    }
}

export const GetGalleriesFailed = (payload: string) => {
    return {
        type: GET_GALLERIES_FAILED,
        payload
    }
}

export const GetSpaces = () => {
    return {
        type: GET_SPACES
    }
}

export const GetSpacesSuccess = (payload: Space[]) => {
    return {
        type: GET_SPACES_SUCCESS,
        payload
    }
}

export const GetSpacesFailed = (payload: string) => {
    return {
        type: GET_SPACES_FAILED,
        payload
    }
}

export const GetUsers = () => {
    return {
        type: GET_USERS
    }
}

export const GetUsersSuccess = (payload: User[]) => {
    return {
        type: GET_USERS_SUCCESS,
        payload
    }
}

export const GetUsersFailed = (payload: string) => {
    return {
        type: GET_USERS_FAILED,
        payload
    }
}

export const GetDefaultSpace = () => {
    return {
        type: GET_DEFAULT_SPACE
    }
}

export const GetDefaultSpaceSuccess = (payload: any) => {
    return {
        type: GET_DEFAULT_SPACE_SUCCESS,
        payload
    }
}
    
export const GetDefaultSpaceFailed = (payload: string) => {
    return {
        type: GET_DEFAULT_SPACE_FAILED,
        payload
    }
}

export const AssignMoodToUser = (payload: any) => {
    return {
        type: ASSIGN_MOOD_TO_USER,
        payload
    }
}

export const AssignMoodToUserSuccess = (payload: any) => {
    return {
        type: ASSIGN_MOOD_TO_USER_SUCCESS,
        payload
    }
}

export const AssignMoodToUserFailed = (payload: string) => {
    return {
        type: ASSIGN_MOOD_TO_USER_FAILED,
        payload
    }
}

export const UnassignMoodFromUser = (payload: any) => {
    return {
        type: UNASSIGN_MOOD_FROM_USER,
        payload
    }
}

export const UnassignMoodFromUserSuccess = (payload: any) => {
    return {
        type: UNASSIGN_MOOD_FROM_USER_SUCCESS,
        payload
    }
}

export const UnassignMoodFromUserFailed = (payload: string) => {
    return {
        type: UNASSIGN_MOOD_FROM_USER_FAILED,
        payload
    }
}